const Benchmark = () => `
    <section class="benchmark" role="region">
        <picture class="benchmark-item">
            <img src="assets/images/100d@2x.png" alt="100d" title="100d" />
            <h2 class="metric"><span id="metric-1">429</span><sup>km</sup></h2>
        </picture>
        <picture class="benchmark-item">
            <img src="assets/images/p100d@2x.png" alt="p100d" title="p100d" />
            <h2 class="metric"><span id="metric-2">434</span><sup>km</sup></h2>
        </picture>
    </section>
`;

export default Benchmark;
